webpackJsonp([273950069227526],{

/***/ 789:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"D:/document/blog/content/pages/1--about/index.md absPath of file >>> MarkdownRemark","html":"<p>I’m Ben. </p>\n<p>I’m a front-end developer. </p>","frontmatter":{"title":"About"}},"footnote":{"id":"D:/document/blog/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":""},"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{"slug":"/about/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-abab5c072b01a86f5c64.js